import { useState, useEffect,useRef } from "react";
import React from 'react';
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
  Input,
  InputGroup,
  Pagination,
  PaginationItem,
  PaginationLink
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { usermanageService } from "../../services/usermanageService.js";
import { clientmanageService } from "../../services/clientmanageService.js";
import 'assets/css/themecustom-style.css';
import { ToastContainer, toast } from 'react-toastify';
import { domainUrl} from '../../constant';
import '@flowjs/flow.js';
import Flow from "@flowjs/flow.js";
import { async } from "@firebase/util";
import { useHistory,useParams } from "react-router-dom";
import { Dropzone, FileItem, FullScreenPreview } from "@dropzone-ui/react";
import Select from 'react-select';
const axios = require("axios");
import { apiUrl } from "../../constant";
import { authtoken } from "global.js";

const BKClient = (props) => {
  const user_info = JSON.parse(localStorage.getItem("user-info"));
  const [currentPage, setCurrentPage] = useState(null);
  const [last_page, setLastPageData] = useState(0);
  const [clientdata, setClientdata] = useState([]);
  const [clientsearch, setclientsearch] = useState([]);
  const [taskdetails,settaskdetails] = useState({});
  const [taskdetailPopup,settaskdetailPopup] = useState(false);
  const [client_err, setclienterr] = useState(false);
  const [file_err, setfileerr] = useState(false);
  const regionOption = useRef(null)

 
  

  
 


useEffect(() => {
  //get_list();
   get_unique_companieslist();
    getBKclient()
}, []);

// const taskDetail = (task_id,index) => {
//   taskmanageService.gettaskdetail(task_id,'','').then((response) => {
//     settaskdetails(response.data.data);
//     settaskdetailPopup(!taskdetailPopup);
//   })
// }
  function setclient(e){ 
    let initdata = {
      client_id: e.value,
    };
    
    setInputfields({ ...inputFields, client_id: e.value });
    setclientsearch(e.value);
    //setClientdata([]);
    
    // var index = e.target.selectedIndex;
    // setclientsearch(e.target[index].text)
   
    
    
  }
const companyfilter = (e,index) => {
 get_list(1,e);

};


const initialStateData = {
  client_data: [],

};
const [inputFields, setInputfields] = useState(initialStateData);

function inputhandler(e) {
    
    if(Array.isArray(e)){   
      setInputfields({...inputFields,client_data : Array.isArray(e) ? e.map(x => x.value) : []})  

    }
  }
 
const [rowsError, setRowsError] = useState(1);
const inputRef = useRef(null);




const [uniquecompanieslist, setUniqueCompaniesData] = useState([]);
function get_unique_companieslist(){
  usermanageService.getclientBK().then((response)=>{
   
    setUniqueCompaniesData(response.data.clients);
  });
}

function add_data(e){
       e.preventDefault();
       // console.log(inputFields);
       // return;
       clientmanageService.addBKclient(inputFields).then((response)=>{
         if(response.status == 200){
          
            toast.success(response.data.message); 
        
            setInputfields({});
            location.reload();
         }else{
           console.log(response.data);
            toast.error(response.data.message);
         }
         
       });

}
  function getBKclient(id) {
      clientmanageService.getBKclient().then((response) => {
       
    console.log(response.data)
          const selectdata = {client_data: (response.data.data) ? response.data.data.map(x => x.value) : []}
          console.log(selectdata)
          setInputfields(selectdata)
          console.log(inputFields)
        });
    }
  return (
    <>
      <Header />
      <Container className="mt--7"  fluid>
      {/* <Row className="align-items-center row">
            <Col xl="6">
              <Button
                className="dash-button "
                color="primary"
                type="button"
                onClick={() => connectDoc()}
              >
                {" "}
              + Connect Docusign{" "}
              </Button>{" "}
            </Col>
            
          </Row> */}
        <Row >
          <div className="col" style={{padding:'0%'}}>
            <Card className="shadow">
            <Form
                role="form"
                id="docusign-form"
                onSubmit={add_data}
              >
              <CardHeader className="border-0">
              <Row className="filter" style={{padding:'0 1%'}}>
               <div className="filter" style={{width:'80%'}}>
               <div className="col-xl-6 col-md-6 col-xs-12">
               <h3 className="clientformtag"> Client</h3>
               
                    {(uniquecompanieslist.length > 0)?
                    <>
                    <Select 
                   
                    className="input-group-alternative mb-3" 
                    name="client_id"
                    options={uniquecompanieslist} // set list of the data
                    onChange={(e) => { inputhandler(e)}}
                    value={(inputFields.client_data) ? uniquecompanieslist.filter(obj => inputFields.client_data.includes(obj.value)) : ''} 
                    searchable
                    isClearable={false}
                    required
                    isMulti
                  />
                  { client_err  && 
                    <span style={{color:'red'}}>Please Select Client</span>
                    }
                    </>
                  
   
                          
                        : null }
                    </div>
                    
                    
                    </div>
                </Row>
                <br></br>
                {/* <div className="filter" style={{width:'80%'}}>
                <div className="col-xl-6 col-md-6 col-xs-12">
                     <h3 className="clientformtag">Message</h3>
                     <Input type="textarea" rows="1" className="col-9" placeholder="Message" name ="message" onChange={inputhandler}/>
                    </div>
                     
                    </div>
          <br></br> */}
                
                <br></br>
              </CardHeader>
              

              <CardFooter >
              
                <Row>
                <div className="filter" style={{width:'80%'}}>
                <div className="col-xl-6 col-md-6 col-xs-12">
                    <Button
                      color="primary"
                      type="button"
                      onClick={add_data}
                    >
                      {" "}
                    + Save{" "}
                    </Button>
                    </div>
                    </div>
                </Row>
              </CardFooter>
                </Form>
            </Card>
          </div>
        </Row>
    

       
      </Container>
    </>
  );
};


export default BKClient;
